<!--  -->
<template>
  <div class="course-list">
    <h2 class="course-name">
      <span></span><b>{{ courseInfo.name }}</b>
    </h2>
    <div class="sku-name" v-if="!courseInfo.productSpecJson">
      <div @click="chooseSingle" :class="{ tabItem: true,common:true, tabSelected: checked }">
        单品<img :src="checkIcon" alt="checkIcon" />
      </div>
    </div>
    <div class="sku-name" v-else v-for="(item, n) in productSpecJson" :key="n">
      <span>{{ item.name }}</span>
      <div class="box">
        <div
          v-for="(list, index) in item.options"
          @click="chooseSkuInfo(list.name, n, $event, index, list.isShow, item)"
          :class="{ tabItem: true,common:true, noneActive: !list.isShow, tabSelected: subIndex[n] == index }"
          :key="index"
        >
          {{ list.name }}<img :src="checkIcon" alt="checkIcon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkIcon from '@/assets/img/components/courseDetail/checkIcon.png';

export default {
  components: {},
  data() {
    return {
      checkIcon,
      selectedIndex: 0,
      productSpecJson: [], // 展示在页面的sku规格
      iconChecked: checkIcon, // sku选中状态icon
      selectArr: [], // 选中的值
      shopItemInfo: {}, // 存放要和选中的值进行匹配的数据
      subIndex: [], // 是否选中
      someOne: null, // 可用的一条sku，用于展示默认的sku
      checked: false,
      chooseSku: {},
    };
  },
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {},
  methods: {
    // 选中sku属性
    chooseSkuInfo(name, n, event, index, canClick, item) {
      if (!canClick) {
        return;
      }
      this.checked = true;
      if (this.selectArr[n] !== name) {
        console.log('选中');
        [this.selectArr[n], this.subIndex[n]] = [name, index];
        this.checkItem();
      } else {
        this.cancleItem(n, index);
      }
    },
    cancleItem(n) {
      const indexArr = JSON.parse(JSON.stringify(this.subIndex));
      const nameArr = JSON.parse(JSON.stringify(this.selectArr));
      indexArr[n] = -1;
      nameArr[n] = '';
      this.subIndex = indexArr;
      this.selectArr = nameArr;
      this.productSpecJson.forEach((ele, p) => {
        if (p !== n) {
          ele.options.forEach((child) => {
            Object.assign(child, { isShow: true });
          });
        }
      });

      if (this.selectArr.every((k) => !k)) {
        this.productSpecJson.forEach((ele) => {
          ele.options.forEach((child) => {
            Object.assign(child, { isShow: true });
          });
        });
      }

      this.sendParentSkuId(this.chooseSku, false);
    },
    checkItem() {
      const self = this;
      let result = this.selectArr; // 定义数组储存被选中的值
      for (let i = 0; i < this.productSpecJson.length; i += 1) {
        result[i] = self.selectArr[i] ? self.selectArr[i] : '';
      }
      if (this.productSpecJson) {
        this.productSpecJson.forEach((element, i) => {
          const last = result[i];
          element.options.forEach((k) => {
            result[i] = k.name;
            Object.assign(k, { isShow: self.someOne ? self.isMay(result) : false }); // isShow来判断是否可以选择})
          });
          result[i] = last; // 还原，目的是记录点下去那个值
        });
      }
      // const flag = result.filter((ele) => ele);
      // console.log(flag);
      // if (flag.length !== result.length) {
      //   this.courseInfo.productSkuRespVOList.find((ele) => {
      //     const values = JSON.parse(ele.specJson)?.map((k) => k.value);
      //     const temp = values.find((ele) => flag.includes(ele));
      //     if (temp && result.filter((ele) => ele)?.length !== this.productSpecJson.length) {
      //       result = values;
      //     }
      //   });
      // }
      if (this.shopItemInfo[result]) {
        this.setDefault([this.shopItemInfo[result]]);
      }
      self.$forceUpdate(); // 重绘
    },
    // 能否被选中
    isMay(result) {
      for (let k = 0; k < result.length; k += 1) {
        if (result[k] === '') {
          return true;
        }
      }
      // 校验list中是否有此条sku
      if (result && !this.shopItemInfo[result]) {
        return false;
      }
      // 库存校验
      return !(
        this.shopItemInfo[result].isSetStock === 1 && this.shopItemInfo[result].availableStock === 0
      );
    },
    // 修改数据结构,将选中的值作为key，以方便和选中之后的值进行匹配
    modifySkuRespVOList() {
      const { productSkuRespVOList, productSpecJson, checked, productSkuId } = this.courseInfo;
      if (!productSpecJson && !productSkuRespVOList?.length) return;
      // 单品
      if (!productSpecJson && productSkuRespVOList.length) {
        // 单品回显
        if (checked) {
          this.chooseSingle();
        }
        return;
      }
      // 多规格
      this.checked = checked;
      // 如果需要选中的规格 没有库存，则不给选中了
      const checkedSkuInfo = productSkuRespVOList.find(
        (item) => item.productSkuId === productSkuId,
      );
      if (checkedSkuInfo?.isSetStock === 1 && checkedSkuInfo?.availableStock <= 0) {
        this.checked = false;
      }
      productSkuRespVOList.forEach((item) => {
        this.shopItemInfo[String(JSON.parse(item.specJson).map((child) => child.value))] = item;
      });

      JSON.parse(productSpecJson).forEach((item) => {
        Object.assign(item, { options: item.options.map((element) => ({ name: element })) });
        this.productSpecJson.push(item);
      });
      // 多规格回显
      if (this.checked) {
        this.setDefault(productSkuRespVOList.filter((item) => item.productSkuId === productSkuId));
      } else {
        this.setDefault(productSkuRespVOList);
      }

      this.checkItem();
    },
    // 默认一个可用的sku
    setDefault(productSkuRespVOList) {
      const defautIdx = [];
      const defautName = [];
      this.someOne = productSkuRespVOList
        ? productSkuRespVOList.find(
            (item) => (item.isSetStock === 1 && item.availableStock > 0) || item.isSetStock === 0,
          )
        : null;
      if (!this.someOne) return;
      if (!this.checked) return;
      this.productSpecJson.forEach((item) => {
        item.options.forEach((list, i) => {
          JSON.parse(this.someOne.specJson).forEach((m) => {
            if (list.name === m.value) {
              defautName.push(list.name);
              defautIdx.push(i);
            }
          });
        });
      });
      // console.log(this.productSpecJson);
      this.subIndex = defautIdx;
      this.selectArr = defautName;
      this.sendParentSkuId(this.someOne, true);
    },
    // 将选中的sku保存到vuex 中
    sendParentSkuId(sku, selected) {
      const course = JSON.parse(JSON.stringify(this.courseInfo));
      course.productSkuId = sku.productSkuId;
      course.selected = selected; //
      this.chooseSku = sku;
      this.$emit('triggerChecked', course);
    },
    chooseSingle() {
      const { productSkuRespVOList } = this.courseInfo;
      const { productSkuId } = productSkuRespVOList[0];
      this.checked = !this.checked;
      this.sendParentSkuId({ productSkuId }, this.checked);
    },
  },
  created() {},
  mounted() {
    this.modifySkuRespVOList();
  },
};
</script>
<style lang="scss" scoped>
.course-list {
  padding: 40px 0 40px 36px;
  border-bottom: 18px solid #f7f8fc;
  .course-name {
    // padding-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 36px;
    span {
      display: inline-block;
      width: 7px;
      height: 29px;
      background: linear-gradient(180deg, #ffae74 0%, #ff6c02 100%);
      border-radius: 5px;
      box-shadow: 0 4px 7px 0 rgba(196, 69, 6, 0.2);
    }
    b {
      padding-left: 18px;
      color: #333;
      font-weight: 600;
      font-size: 29px;
      line-height: 40px;
    }
  }
  .sku-name {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    span {
      flex-shrink: 0;
      box-sizing: border-box;
      width: 110px;
      // padding-top: 26px;
      padding-right: 25px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 30px;
    }
    .box{
      display: flex;
      flex-wrap: wrap;
    }
    .common {
      position: relative;
      display: inline-block;
      width: 185px;
      height: 54px;
      margin: 11px 11px 11px 0;
      padding: 0 5px;
      overflow: hidden;
      color: #333;
      font-weight: 400;
      font-size: 22px;
      line-height: 54px;
      text-align: center;
      background: #fff;
      border: 2px solid #e8e8e8;
      border-radius: 4px;
      img {
        position: absolute;
        right: 0;
        bottom: 0;
        display: none;
        width: 30px;
        height: auto;
      }
    }
    div:nth-child(5n) {
      margin-left: 73px;
    }
    div:nth-child(4n) {
      // margin-left: 73px;
      margin-right: 0;
    }
    .tabSelected {
      box-sizing: border-box;
      color: #ff6c02;
      background: rgba(255, 108, 2, 0.1);
      border: 2px solid rgba(255, 108, 2, 0.5);
      border-radius: 7px;
      // pointer-events: none;
      img {
        display: block;
      }
    }
    .noneActive {
      color: #a5a5a5;
      background: #fafafa;
      border: 2px solid #eee;
      border-radius: 7px;

      img {
        display: none;
      }
    }
  }
}
</style>
